<app-breadcrumbs [headerTitle]="'TPP SERVICE DEFINITION'" />
<div class="tpp-paygroup-list-container">
	<div class="main-container">
		<app-paygroup-select (selectedPayGroup)="handlePayGroupSelected()"> </app-paygroup-select>
	</div>
</div>
